import React, { useState, useEffect } from "react";
import { LOCALE } from "../../properties/Locale";
import { Link, Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { useDispatch } from "react-redux";
import {
  changePageTitle,
  notifyShowSuccessMessage,
} from "../../common/actions/CommonActions";
import {
  TextField,
  Grid,
  Paper,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardMedia,
  Dialog,
  DialogActions,
  CircularProgress,
  DialogContent,
  IconButton,
  Icon,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import EntityMetadata from "../../common/components/EntityMetadata";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import CardBody from "../../common/components/Card/CardBody";
import Card from "../../common/components/Card/Card";
import CardHeader from "../../common/components/Card/CardHeader";
import { VacancyRepository } from "./VacancyRepository";

const useStyles = makeStyles(styles);

export default function VacancyDetailsComponent(props) {
  const classes = useStyles();
  const [vacancyId] = useState(props.match.params.vacancyId);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadVacancy = (id) => {
      setLoading(true);
      VacancyRepository.findById(id).then((res) => {
        setData(res.data);
        setLoading(false);
      });
    };

    loadVacancy(vacancyId);
  }, [vacancyId]);

  return (
    <div>
      <Card>
        <Dialog
          open={true}
          onClose={() => {}}
          maxWidth="md"
          fullWidth={true}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.vacancy_details}${
                data?.name ? ": " + data?.name : ""
              }`}
              <Link to={`/app/vacancy`} style={{ textDecoration: "none" }}>
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            <DialogContent>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    label={LOCALE.name}
                    variant="outlined"
                    value={data?.name ? data?.name : ""}
                    size="small"
                    margin="dense"
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    label={LOCALE.description}
                    multiline={true}
                    rows={3}
                    margin="dense"
                    size="small"
                    variant="outlined"
                    value={data?.description ? data?.description : ""}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    margin="dense"
                    label="Шема за оценување"
                    size="small"
                    variant="outlined"
                    value={
                      data?.gradingSchema.name ? data?.gradingSchema.name : ""
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    label="Тип на конкурс"
                    size="small"
                    variant="outlined"
                    margin="dense"
                    value={
                      data?.vacancyType === "TEACHER_MENTOR"
                        ? "Наставник - Ментор"
                        : data?.vacancyType === "TEACHER_ADVISOR"
                        ? "Наставник-Советник"
                        : data?.vacancyType === "ASSOCIATE_MENTOR"
                        ? "Стручен Соработник-Ментор"
                        : data?.vacancyType === "ASSOCIATE_ADVISOR"
                        ? "Стручен Соработник-Советник"
                        : ""
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disabled={true}
                        disableToolbar
                        format="MM/dd/yyyy"
                        inputVariant="outlined"
                        margin="dense"
                        id="date-from"
                        label={LOCALE.startDate}
                        value={data && data.startDate}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={5}>
                  <FormControl fullWidth>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disabled={true}
                        disableToolbar
                        format="MM/dd/yyyy"
                        margin="dense"
                        inputVariant="outlined"
                        id="date-to"
                        label={LOCALE.endDate}
                        value={data && data.endDate}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.commission_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.commissionEvalStartDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.commissionEvalEndDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.bureau_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.bureauEvalStartDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.bureauEvalEndDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>{LOCALE.max_points}</Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.commission}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsCommission}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.advisor}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsAdvisor}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={2}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.school}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsSchool}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.total}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.maxPointsTotal}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>
                      {LOCALE.min_points_for_commision_eval}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.training}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsTraining}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={5}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.professional_development}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsCommission}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10} style={{ textAlign: "center" }}>
                    {" "}
                    <Typography>{LOCALE.min_points_for_ranklist}</Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.commission}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsRanglistCommission}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.advisor}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsRanglistAdvisor}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    {" "}
                    <TextField
                      fullWidth
                      disabled={true}
                      label={LOCALE.school}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={data && data.minPointsRanglistSchool}
                      margin="dense"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                </Grid>{" "}
              </div>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.eduCenter_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.eduCenterEvalStartDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.eduCenterEvalEndDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={5}>
                  <Paper variant="outlined" style={{ padding: "7px" }}>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      {LOCALE.school_eval}
                    </Typography>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          inputVariant="outlined"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.startDate}
                          value={data && data.schoolEvalStartDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl fullWidth>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={true}
                          disableToolbar
                          format="MM/dd/yyyy"
                          margin="dense"
                          inputVariant="outlined"
                          id="date-to"
                          label={LOCALE.endDate}
                          value={data && data.schoolEvalEndDate}
                        />
                      </MuiPickersUtilsProvider>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <FormControl fullWidth disabled={true}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={true}
                          checked={data && data.isCustom}
                          value={data && data.isCustom}
                          name="Дали конкурсот се однесува на одредена листа на училишта?"
                        />
                      }
                      label="Дали конкурсот се однесува на одредена листа на училишта?"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <EntityMetadata data={data} />
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Link to={`/app/vacancy`} style={{ textDecoration: "none" }}>
                <Button size="small" variant="outlined" color="secondary">
                  {LOCALE.close}
                </Button>
              </Link>
            </DialogActions>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
